export enum ShopifyStore {
    JUNIPER_SALES = "junipersales",
    LANKYBOX_STORE = "lankyboxstore",
    JUNIPER_CREATES = "junipercreates",
    ANOTHER_AXIOM = "another-axiom-x-juniper",
}

export const ShopifyStoreDisplayValues: Record<ShopifyStore, string> = {
    [ShopifyStore.JUNIPER_SALES]: "junipersales",
    [ShopifyStore.LANKYBOX_STORE]: "lankyboxstore",
    [ShopifyStore.JUNIPER_CREATES]: "junipercreates",
    [ShopifyStore.ANOTHER_AXIOM]: "another-axiom-x-juniper",
};
